/* eslint-disable array-callback-return */
import { useEffect, useRef, useState, useCallback } from 'react';
import { Singleton } from '../../../core/services/Singleton';
import { ExportXLSL } from './ExportXLSX';
import "./basictable.css";
import { HeadTable } from './basictable/HeadTable';
import { env } from '../../../env';
import { _single } from '../../../core/services/dataBean/EntityCatalog';
import { FilterModal } from './FilterModal';
import { toast } from 'react-toastify';
import { TableRow } from './TableRow';


export const MASK_NUMBER = 1;
export const MASK_NUMBER_ROUND = 11;
export const MASK_DECIMAL = 12;
export const MASK_MONEY = 2;
export const MASK_MONEY_ROUND = 22;
export const MASK_TEXT = 3;
export const MASK_TEXT_NOWRAP = 33;
export const MASK_MYEDITOR = 4;
export const MASK_DATE = 5;
export const MASK_DATE_DDMMMYYYY = 6;
export const MASK_DATE_YYYYMMDD_HHMM = 66;
export const MASK_BOOLEAN_ICON = 7;
export const MASK_BOOLEAN = 77;

export interface dataFormat {
    list: any[];
    dataColumns: any[];
}

interface paginadorProps {
    page: number,
    pages: number,
    records: number,
    regiPerPage: number,
    setRegiPerPage: Function,
    setPage: Function,
    setPages: Function,
    setRecords: Function,
}

interface Props {
    head: any,
    body: any;
    rowSet: any;
    headButtons?: any;
    listButtons?: any;
    iconButtons?: any;
    pageTop?: number;
    records?: Partial<paginadorProps>;
    next?: any;
    back?: any;
    setSelectPage?: (page: number) => void;
    callBack?: any;
    cssTable?: string;
    customRows?: number;
    filterModal?: any;
    _returnCellValue?: Function;
    _exportList?: boolean;
    _exportFormat?: any;

}
export const BasicTable = ({ head, body, rowSet, headButtons, listButtons, iconButtons, pageTop, records, next, back, callBack, cssTable, customRows, _returnCellValue, filterModal, _exportList, _exportFormat, setSelectPage }: Props) => {

    const [row, setRow] = useState(-1);
    const [rowMenu, setRowMenu] = useState(-1);
    const [rowData, setRowData] = useState<any>({});
    const [mbody, setMbody] = useState<any>([]);
    const [titulo, setTitulo] = useState<any>([]);
    const single = Singleton.getInstance()
    const [search, setSearch] = useState("");
    const [original, setOriginal] = useState<any>([]);
    const [filtro, setFiltro] = useState('');
    const [modalbusqueda, setModalBusqueda] = useState(false);
    const [modalColumna, setModalColumna] = useState(false);
    const [verMas, setVerMas] = useState(false);

    const printLog = env.PRINT_LOG ?? false;
    const botonera = useRef<any>(listButtons);

    const [menuVisible, setMenuVisible] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

    const [currentIndex, setCurrentIndex] = useState(NaN);

    //paginador interno
    const [page, setPage] = useState<number>(1);
    const [rows, setRows] = useState<number>(15);

    useEffect(() => {
        if (customRows) {
            setRows(customRows);
            paginar();

        }

    }, [customRows])

    useEffect(() => {
        if (customRows)
            setRow(customRows);
        return () => closeMenu();
    }, [])

    useEffect(() => {
        if (page > 0) {
            paginar();
            let t = single.currentURI;
        }
    }, [page, rows, original]);

    useEffect(() => {
        if (body) {
            updateTitulo();
            setOriginal(Array.isArray(body) ? body : []);
            // setMbody(body.slice(0,rows));
            // setMbody(Array.isArray(body) ? body : []);
            // paginar();
        }
        // return () => {
        //     setOriginal([]);
        // }
    }, [body]);

    const openMenu = useCallback((event: React.MouseEvent<HTMLElement>, index: number) => {
        const clickY = event.clientY;

        const targetRect = event.currentTarget.getBoundingClientRect();
        const centerX = (targetRect.left + targetRect.width / 2) - 8;

        // Posición inicial
        setMenuPosition({ top: clickY, left: centerX });
        setMenuVisible(true);
        setRowMenu(index);

        // Luego de renderizar, ajusta la posición si no cabe abajo
        setTimeout(() => {
            const el = document.querySelector('.listMenu');
            if (el instanceof HTMLElement) {
                const menuHeight = el.offsetHeight;
                const spaceBelow = window.innerHeight - clickY;

                const top = spaceBelow < menuHeight ? clickY - menuHeight : clickY;
                setMenuPosition({ top, left: centerX });
            }
        }, 0);
    }, []);

    const closeMenu = () => {
        setMenuVisible(false);
        setRowMenu(-1);
    };

    const updateTitulo = () => {
        if (head) {
            head.forEach((element: any) => {
                if (element.visible === undefined) {
                    element.visible = true;
                }
            });
            setTitulo(head);
        }
    }

    const paginar = () => {
        try {
            let sup = (page <= 1 ? rows : page * rows);
            let inf = sup - rows;

            setMbody(body.slice(inf, sup));
        } catch (error) {
            // console.error(error);
        }
    }


    useEffect(() => {
        filter();
    }, [search])

    // ... comments omitted for brevity ...
    // ... comments omitted for brevity ...
    // ... comments omitted for brevity ...
    // ... comments omitted for brevity ...
    // ... comments omitted for brevity ...
    // ... comments omitted for brevity ...

    const updateTitle = (item: any) => {
        let t = titulo;
        t.forEach((element: any) => {
            if (element.property == item.property) {
                element.visible = element.visible === true ? false : true;
            }
        });
        setTitulo(t);
    }

    const filter = () => {
        let temporal: any = [];
        let tmp = '';
        original.forEach((item: any) => {
            tmp = item.DataBeanProperties[filtro];

            if (typeof tmp === 'number') {
                if (item.DataBeanProperties[filtro] == search) {
                    temporal.push(item);
                }
            }
            else if (typeof tmp === 'string') {
                if (item.DataBeanProperties[filtro].toLocaleLowerCase().includes(search.toLocaleLowerCase())) {
                    temporal.push(item);
                }
            }
        });

        setMbody(temporal);
    }

    const listaColumnas = () => {
        return (
            <>
                <div className="alert alert-primary alert-dismissible alert-outline shadow fade show" role="alert">
                    <div className="row mt-4" >
                        <div className="col">
                            <div className="form-group colsize">
                                {titulo.map((item: any, index: number) => {
                                    return (
                                        <div key={index} className="form-check">
                                            <input className="form-check-input" defaultChecked={item.visible} type="checkbox" value={item.title} id={item.property}
                                                onClick={() => { updateTitle(item) }}
                                            />
                                            <label style={{ marginTop: '-5px' }} htmlFor={item.property}>
                                                {item.title}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <button type="button" className="btn-close" onClick={() => { setModalColumna(false) }}   ></button>
                </div>
            </>
        )
    }


    const onClickTable = useCallback((obj: any, index: number) => {
        rowSet(obj.DataBeanProperties);
        setRowData(obj.DataBeanProperties);
        setCurrentIndex(index);
        _single.printOut(obj.DataBeanProperties);
    }, [rowSet]);

    const onClickCell = useCallback((value: any) => {
        if (_returnCellValue) {
            _returnCellValue(value);
        }
    }, [_returnCellValue]);

    const [usePage, setUsePage] = useState<number>(records?.page ?? 1);

    useEffect(() => {
        if (records?.page && !isNaN(records.page) && records.page >= 1 && records.page != usePage) {
            setUsePage(records.page)
        }
    }, [records?.page])

    const goBack = () => {
        if (records && records.page)
            records.setPage?.(records.page - 1);
    };

    const goNext = () => {
        if (records && records.page)
            records.setPage?.(records.page + 1);
    };

    const [temporalPage, setTemporalPage] = useState<string | number>("1");

    useEffect(() => { if (page != temporalPage) setTemporalPage(page) }, [page])

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="row ">
                        <div className="col-md-12">
                            {headButtons}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-between mt-4 mb-2">
                                <div className="paginador">
                                    {records ?
                                        <>
                                            <div className="row">
                                                <div className="col d-flex align-items-center">
                                                    {(records.page > 1) && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none"
                                                            onClick={() => { goBack() }}
                                                        >
                                                            <i className="ri-skip-back-fill"></i>
                                                        </button>
                                                    )}

                                                    <span style={{ padding: '5px' }}>
                                                        <input
                                                            type="number"
                                                            className="form-control d-inline-block"
                                                            style={{ width: "60px", textAlign: "center", display: "inline", height: "35px" }}
                                                            value={usePage}
                                                            min={1}
                                                            max={records.pages}
                                                            onChange={(e) => {
                                                                const valueEdit = e.target.value ? Number(e.target.value) : null;
                                                                if (valueEdit) setUsePage(valueEdit);
                                                            }}
                                                            onBlur={(e) => {
                                                                const pageData = Number(e.target.value);
                                                                if (!isNaN(pageData) && pageData >= 1 && pageData <= records.pages) {
                                                                    setUsePage(pageData);
                                                                    records.setPage?.(pageData);
                                                                } else {
                                                                    toast.error("Debe digitar una página válida");
                                                                }
                                                            }}
                                                        />
                                                        <span className="ms-2">de {records.pages}</span>
                                                    </span>

                                                    {(records.page < records.pages) && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none"
                                                            onClick={() => { goNext() }}
                                                        >
                                                            <i className="ri-skip-forward-fill"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                        </>
                                        :
                                        <>
                                            {body?.length > 0 &&
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        {page > 1 &&
                                                            // <button type="button" className="btn bot-clas waves-effect waves-light shadow-none" onClick={() => { setPage(page - 1) }}>Anterior</button>
                                                            <button type="button" className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none" onClick={() => { setPage(page - 1) }}><i className="ri-skip-back-fill" ></i></button>
                                                        }

                                                        <span style={{ padding: '5px' }}>
                                                            <input
                                                                type="number"
                                                                className="form-control d-inline-block"
                                                                style={{ width: "60px", textAlign: "center", display: "inline", height: "35px" }}
                                                                value={temporalPage}
                                                                onChange={(e) => setTemporalPage(e.target.value)}
                                                                onBlur={() => {
                                                                    const pageData = Number(temporalPage);
                                                                    if (!isNaN(pageData) && pageData >= 1 && pageData <= Math.ceil(body.length / rows)) {
                                                                        setPage(pageData);
                                                                    } else {
                                                                        toast.error("Debe digitar una página válida");
                                                                        setTemporalPage(page);
                                                                    }
                                                                }}
                                                            />
                                                            <span className="ms-2">de {Math.ceil(body.length / rows)}</span>
                                                        </span>

                                                        {Math.floor(page * rows) < (body.length) &&
                                                            // <button type="button" className="btn bot-clas waves-effect waves-light shadow-none" onClick={() => { setPage(page + 1) }}>Siguiente</button>
                                                            <button type="button" className="btn btn-outline-primary btn-icon waves-effect waves-light shadow-none" onClick={() => { setPage(page + 1) }}><i className="ri-skip-forward-fill" ></i></button>
                                                        }
                                                    </div>
                                                    {/* <div className="col-md-12   ">
                                                        {records && typeof records.records === 'number' ? (
                                                            <>
                                                                {`${records.records} Registros`}
                                                            </>
                                                        ) : (
                                                            <span style={{ padding: '5px' }}>
                                                                Registros: {body.length}
                                                            </span>
                                                        )}
                                                    </div> */}
                                                </div>
                                            }
                                        </>
                                    }
                                </div>


                                {/* botones auxiliares a la tabla */}

                                <div className=''>
                                    {iconButtons && iconButtons.map((btn: any, index: number) => {
                                        return (
                                            btn.visible && (
                                                <button key={index} title={btn.nombre} type="button" className="btn btn-icon" onClick={btn.evento}>
                                                    <i className={btn.icono}></i>
                                                </button>
                                            )
                                        );
                                    })}

                                    {!records?.page &&
                                        <button title='Buscar' type="button" className="btn btn--primary btn-icon" onClick={() => { setModalBusqueda(true) }}>
                                            <i className=" ri-file-search-line icontable"></i>
                                        </button>
                                    }
                                    {filterModal &&
                                        <FilterModal component={filterModal} />
                                    }

                                    {head.length > 0 &&
                                        <button disabled={!rowData.hasOwnProperty(head[0].property)} title='Ver' type="button" className="btn btn--primary btn-icon" onClick={() => { setVerMas(true) }}>
                                            <i className=" ri-eye-line icontable"></i>
                                        </button>
                                    }

                                    <button title='Columnas' type="button" className="btn btn--primary btn-icon " onClick={() => { setModalColumna(true) }}>
                                        <i className="ri-layout-grid-line icontable icontable"></i>
                                    </button>
                                    {_exportFormat &&
                                        <button title='Formato para importar XLSX' type="button" className="btn btn--primary btn-icon " onClick={() => { _exportFormat(true) }}>
                                            <i className={'ri-file-list-line icontable icontable'}></i>
                                        </button>
                                    }
                                    {(!records?.page || _exportList) &&
                                        <ExportXLSL title={head} data={body} onExport={(name: string) => {
                                            single.download("formato xlsx [" + name + "] con " + body.length + " registros");
                                        }} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            {modalbusqueda &&
                                <div className="busquedatable " tabIndex={-1}>
                                    <div className="alert alert-primary alert-dismissible alert-outline shadow fade show" role="alert">
                                        <div className="row">
                                            <div className="col">
                                                <label>Columna</label>
                                                <select className="form-select mb-3" onChange={(e) => { setFiltro(e.target.value); setMbody(original); setSearch('') }}>
                                                    <option value="0">...</option>
                                                    {titulo.map((item: any, index: number) => {
                                                        return (
                                                            <option key={index} value={item.property}>{item.title}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                            <div className="col">
                                                <label>Búsqueda</label>
                                                <input type="text" onChange={(e) => setSearch(e.target.value)} className="form-control inputBuscar " placeholder="Filtrar datos" />
                                            </div>
                                        </div>
                                        <button type="button" className="btn-close" onClick={() => { setModalBusqueda(false) }}   ></button>
                                    </div>
                                </div>
                            }

                            {modalColumna &&
                                <div className="busquedatable" tabIndex={-1}>
                                    {listaColumnas()}
                                </div>
                            }

                            {verMas &&
                                <div className="fixed-top">
                                    <div className="verFilatabla">
                                        <div className="alert alert-primary alert-dismissible alert-outline shadow fade show" role="alert">
                                            <div className="row">
                                                <div className="col">
                                                    <table className='table table-striped mt-4'>
                                                        <tbody className="text-justify">
                                                            {head.map((item: any, index: number) =>
                                                            (
                                                                <tr key={index}>
                                                                    <td>{item.title}</td>
                                                                    <td>{<div className='h6' dangerouslySetInnerHTML={{ __html: single.formatField(rowData[item.property]) }}></div>}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <button type="button" className="btn-close" onClick={() => { setVerMas(false) }}   ></button>
                                        </div>
                                    </div>
                                </div>
                            }
                            {menuVisible && (
                                <div className='position-fixed listMenu' onMouseLeave={closeMenu}

                                    style={{
                                        zIndex: '900',
                                        top: `${menuPosition.top}px`,
                                        left: `${menuPosition.left + 14}px`,

                                    }}
                                >
                                    <div onClick={closeMenu}>
                                        {listButtons}
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className={cssTable ?? "table-responsive1"}>

                                <table key={single.getRandomInt()} className="table  table-striped-columns   mb-0" id="tabla"  >
                                    <HeadTable key={_single.getRandomInt()} listButtons={listButtons} titulo={titulo} />
                                    <tbody >
                                        {Array.isArray(mbody) &&
                                            mbody.map((bean: any, index: number) => {
                                                return (
                                                    <TableRow
                                                        key={index}
                                                        bean={bean}
                                                        index={index}
                                                        isSelected={currentIndex === index}
                                                        isMenuOpen={index === rowMenu}
                                                        titulo={titulo}
                                                        listButtons={listButtons}
                                                        onRowClick={onClickTable}
                                                        onMenuClick={openMenu}
                                                        onCellClick={onClickCell}
                                                        callBack={callBack}
                                                    />
                                                )
                                            })
                                        }
                                        {Array.isArray(mbody) && mbody.length === 0 &&
                                            <tr>
                                                <td colSpan={head.length}>
                                                    No hay datos para mostrar.
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>

    )
}
